<app-header [label]="page_name | plural"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4">
  <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
  <div class="flex gap-2">
    <app-button color="bg-secondary text-[#310000]" label="GO BACK" routerLink="/dashbaord"></app-button>
  </div>
</div>
<app-ag-grid-list [list]="items" [colDefs]="cols" [itemName]="page_name" (bulkDelete)="bulk_delete($event)"></app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  This action cannot be undone, and all associated data will be permanently removed.
</app-confirmation-popup>